export enum StorageQuotaUseCase {
  COPY = 'copy',
  UPLOAD = 'upload',
  VIDEO_MAKER = 'video_maker',
  MEDIA_STUDIO = 'media_studio',
  ADOBE_EXPRESS = 'adobe_express',
  SHUTTERSTOCK_PURCHASE = 'shutterstock_purchase',
}
